<template>
    <div class="wine-list">
        <div class="wine-list--inner">
            <div class="modal" v-if="deleteModalVisible" v-on:click="hideDeleteModal">
                <div class="modal--body" v-on:click.stop>
                    <p>
                        Den Merkzettel wirklch leeren?
                    </p>
                    <div class="modal--buttons">
                        <button class="btn btn-sm btn-secondary" v-on:click="hideDeleteModal">nein</button>
                        <button class="btn btn-sm btn-primary" v-on:click="emptyWineList">Ja</button>
                    </div>
                </div>
            </div>
            <h1>Merkzettel</h1>
            <div class="share-form">
                <a v-bind:href="shareLink" target="_blank" class="btn btn-sm btn-light">Teilen <icon-mail class="mail-icon" color="#fff"></icon-mail></a>
                <button v-on:click="showDeleteModal" class="btn btn-sm btn-light">Merkzettel leeren <icon-close class="delete-icon" color="#fff"></icon-close></button>
            </div>
            <div class="winery-list">
                <div class="winery" v-for="winery in wineries">
                    <div class="winery--title" v-on:click="toggleWineryVisible(winery)">
                        {{winery.standnummer}}.) {{winery.title}}
                        <icon-arrow v-bind:direction="isWineryVisible(winery) ? 'up' : 'down'" class="toggle-arrow"></icon-arrow>
                    </div>

                    <div class="winery--details" v-if="isWineryAddressVisible(winery)">
                        <div class="winery--address">
                            {{winery.address}}<br>
                            {{winery.zipcode}} {{winery.city}}
                        </div>
                        <div class="winery--phone" v-if="winery.phone">
                            Telefon {{winery.areacode}}/{{winery.phone}}
                        </div>
                        <div class="winery--fax" v-if="winery.fax">
                            Telefax {{winery.areacode}}/{{winery.fax}}
                        </div>
                        <div class="winery--email" v-if="winery.email">
                            E-Mail {{winery.email}}
                        </div>
                        <div class="winery--website" v-if="winery.website">
                            Internet <a v-bind:href="makeUrl(winery.website)" target="_blank" rel="noopener">{{winery.website}}</a>
                        </div>
                    </div>
                    <div class="winery--details" v-else>
                        <div class="winery--address" v-on:click="showWineryAddress(winery)">
                            {{winery.zipcode}} {{winery.city}}
                            <icon-arrow direction="down" class="toggle-arrow"></icon-arrow>
                        </div>
                    </div>

                    <div class="winery--wine-list" v-if="isWineryVisible(winery)">
                        <div class="winery--wine" v-for="wine in winery.wines">
                            <div class="wine--list-button">
                                <circle-button v-on:click="toggleWineToList(wine)">
                                    <icon-minus color="#fff" v-if="isWineInList(wine)"></icon-minus>
                                    <icon-plus color="#fff" v-else></icon-plus>
                                </circle-button>
                            </div>
                            <div class="wine--year">{{wine.year}}</div>
                            <div class="wine--details">
                                <div class="wine--title">
                                    <span v-if="wine.grapeType && wine.grapeType.title !== '... keine Angabe'">{{wine.grapeType.title}} </span>
                                    <span v-if="wine.wineType && wine.wineType.title !== 'keine Angabe' && wine.wineType.title !== 'Weißwein'">{{wine.wineType.title}} </span>
                                    <span>{{wine.title}}</span>
                                </div>
                                <div class="wine--quality" v-if="wine.wineQuality">{{wine.wineQuality.title}}</div>
                                <div class="wine--taste" v-if="wine.wineTaste">{{wine.wineTaste.title}}</div>
                                <div class="wine--taste" v-if="wine.wineBuildup">{{wine.wineBuildup.title}}</div>
                                <div class="wine--taste" v-if="wine.lage">{{wine.lage}}</div>
                                <div class="wine--note" v-bind:class="{'active': isNoteVisible(wine)}">
                                    <div class="note--button"  v-on:click="toggleNote(wine)">
                                        <span v-if="hasNote(wine)">Notiz ansehen</span>
                                        <span v-else>Notiz schreiben</span>
                                        &nbsp;
                                        <icon-arrow v-bind:direction="isNoteVisible(wine) ? 'up' : 'down'"></icon-arrow>
                                    </div>
                                    <div class="note--body" v-on:input="updateNote(wine, $event.target.innerText)" v-bind:id="'note--body--' + wine.id" contenteditable="true" v-if="isNoteVisible(wine)"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconArrow from "../components/icons/IconArrow";
    import CircleButton from "../components/CircleButton";
    import IconMinus from "../components/icons/IconMinus";
    import IconPlus from "../components/icons/IconPlus";
    import IconMail from "../components/icons/IconMail";
    import IconClose from "../components/icons/IconClose";

    export default {
        name: "WineList",

        components: {
            IconClose,
            IconMail,
            IconPlus,
            IconMinus,
            CircleButton,
            IconArrow
        },

        data() {
            return {
                wineriesHidden: [],
                wineryAddressesVisible: [],
                notesVisible: [],
                deleteModalVisible: false
            }
        },

        computed: {
            wineList() {
                return this.$store.state.wineList;
            },

            wineries() {
                return this.$store.getters.wineries
                    .map(winery => {
                        let wineryCopy = Object.assign({}, winery);

                        wineryCopy.wines = winery.wines.filter(wine => {
                            return this.wineList.findIndex(item => item.wineId === wine.id) >= 0;
                        });

                        return wineryCopy;
                    })
                    .filter(winery => winery.wines.length > 0);
            },

            shareLink() {
                let body = 'Weinerlebnis 2026 Merkzettel\n\n';

                body += 'Wir freuen uns, dass Ihnen verschiedene Weine die bei dem Weinerlebnis der Südlichen Weinstraße 2026 gefallen haben. Folgend finden sie die Weine, die Sie in Ihrer Merkliste abgelegt hatten:\n\n';

                body += '---------\n\n';

                body += this.wineries.reduce((text, winery) => {
                    return text
                        + winery.standnummer + '.) ' + winery.title + '\n\n'
                        + winery.wines.reduce((text, wine) => {
                            let title = [];

                            if (wine.grapeType && wine.grapeType.title !== '... keine Angabe') {
                                title.push(wine.grapeType.title);
                            }

                            if (wine.wineType && wine.wineType.title !== 'keine Angabe' && wine.wineType.title !== 'Weißwein') {
                                title.push(wine.wineType.title);
                            }

                            if (wine.title !== '') {
                                title.push(wine.title);
                            }

                            let details = [];

                            if (wine.wineQuality) {
                                details.push(wine.wineQuality.title);
                            }

                            if (wine.wineTaste) {
                                details.push(wine.wineTaste.title);
                            }

                            if (wine.wineBuildup) {
                                details.push(wine.wineBuildup.title);
                            }

                            if (wine.lage) {
                                details.push(wine.lage);
                            }

                            if (this.hasNote(wine)) {
                                details.push('Notiz:\n' + this.getNote(wine));
                            }

                            return text
                                + title.join(' ') + '\n'
                                + details.join('\n') + '\n\n';
                        }, '')
                        + '---------\n\n';
                }, '');

                return 'mailto:'
                    + '?subject=' + encodeURIComponent('Weinerlebnis 2026 - Merkzettel')
                    + '&body=' + encodeURIComponent(body);
            }
        },

        methods: {
            makeUrl(url) {
                return url.substr(4) !== 'http' ? 'http://' + url : url;
            },

            isWineryVisible(winery) {
                return !this.wineriesHidden.find(id => id === winery.id)
            },

            isWineryAddressVisible(winery) {
                return !!this.wineryAddressesVisible.find(id => id === winery.id)
            },

            showWinery(winery) {
                this.wineriesHidden = this.wineriesHidden.filter(id => id !== winery.id);
            },

            hideWinery(winery) {
                this.wineriesHidden.push(winery.id);
                this.wineryAddressesVisible = this.wineryAddressesVisible.filter(id => id !== winery.id);
            },

            showWineryAddress(winery) {
                this.wineryAddressesVisible.push(winery.id);
            },

            toggleWineryVisible(winery) {
                if (this.isWineryVisible(winery)) {
                    this.hideWinery(winery);
                } else {
                    this.showWinery(winery);
                }
            },

            toggleWineToList(wine) {
                if (this.isWineInList(wine)) {
                    this.$store.commit('removeWineFromList', wine);
                } else {
                    this.$store.commit('addWineToList', wine);
                }
            },

            isWineInList(wine) {
                return this.$store.state.wineList.findIndex(item => item.wineId === wine.id) >= 0;
            },

            toggleNote(wine) {
                if (this.isNoteVisible(wine)) {
                    this.hideNote(wine);
                } else {
                    this.showNote(wine);
                }
            },

            showNote(wine) {
                this.notesVisible.push(wine.id);

                this.$nextTick(() => {
                    let el = document.getElementById('note--body--' + wine.id);

                    if (el) {
                        el.innerText = this.getNote(wine);

                        if (!this.hasNote(wine)) {
                            el.focus();
                        }
                    }
                });
            },

            hideNote(wine) {
                this.notesVisible = this.notesVisible.filter(wineId => wineId !== wine.id);
            },

            isNoteVisible(wine) {
                return !!this.notesVisible.find(id => id === wine.id)
            },

            hasNote(wine) {
                return this.getNote(wine) !== '';
            },

            getNote(wine) {
                return this.$store.getters.getNote(wine.id);
            },

            updateNote(wine, note) {
                this.$store.commit('setNoteOnWineList', {wine, note});
            },

            hideDeleteModal() {
                this.deleteModalVisible = false;
            },

            showDeleteModal() {
                this.deleteModalVisible = true;
            },

            emptyWineList() {
                this.hideDeleteModal();
                this.$store.commit('emptyWineList');
            }
        },

        mounted() {
            this.wineList.forEach(wine => {
                if (wine.note !== '') {
                    this.notesVisible.push(wine.wineId);

                    this.$nextTick(() => {
                        let el = document.getElementById('note--body--' + wine.wineId);

                        if (el) {
                            el.innerText = wine.note;
                        }
                    });
                }
            });
        }
    }
</script>

<style lang="scss" scoped>
    a.btn {
        text-decoration: none;
    }

    .wine-list {
        background-color: $primary;
    }

    .wine-list--inner {
        margin: 0 auto;
        padding: 30px 0;
        width: $content-width;
        text-align: center;
    }

    .winery {
        text-align: left;
        margin: 20px 0;
    }

    .winery--title {
        font-size: 12px;
        font-family: $font-family-sans-serif;
        font-weight: bold;
        text-transform: uppercase;
    }

    .winery--website {
        a {
            color: $body-color;
        }
    }

    .winery--wine {
        margin: 20px 0;
        display: flex;
        justify-content: space-between;
    }

    .wine--list-button {
        position: relative;
        top: -6px;
    }

    .wine--title {
        font-weight: bold;
    }

    .wine--details {
        width: 50%;
    }

    .toggle-arrow {
        padding-left: 4px;
        width: 14px;
        height: 10px;
        margin-right: -14px;
    }

    .share-form {
        display: flex;
        justify-content: space-between;
        margin: 20px 0;

        .btn {
            font-size: 10px;
            background-color: #915058;
            border-color: #915058;
            color: #fff;

            &:hover,
            &:not(:disabled):not(.disabled):active,
            &:not(:disabled):not(.disabled).active,
            .show > &.dropdown-toggle {
                background-color: #915058;
                border-color: #915058;
                color: #fff;
            }
        }
    }

    .mail-icon  {
        position: relative;
        top: -1px;
        width: 22px;
        height: 14px;
    }

    .delete-icon {
        position: relative;
        top: -1px;
        width: 18px;
        height: 10px;
    }

    .wine--note {
        margin-left: -50px;
        margin-top: 5px;

        &.active {
            background-color: #fff;
            border-radius: $border-radius;

            .note--button {
                font-weight: bold;
            }
        }
    }

    .note--button {
        display: inline-block;
        background-color: #fff;
        padding: 3px 5px;
        border-radius: $border-radius;
    }

    .note--body {
        padding: 3px 5px;

        &:focus {
            outline: none;
        }
    }

    .modal {
        background-color: transparentize(#000, 0.25);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 500;
    }

    .modal--body {
        @include shadow;

        background-color: #fff;
        padding: 20px;
        width: 300px;
    }

    .modal--buttons {
        text-align: right;

        .btn {
            font-size: 10px;
            min-width: 75px;
            margin-left: 5px;
        }
    }
</style>
